export enum AddOnType {
    QUANTITY = "quantity",
    DROPDOWN = "dropdown",
    CHECKBOX = "checkbox",
}
